import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { OutboxStatusEnum } from '../enums/outbox-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function outboxStatusToColor(status: OutboxStatusEnum): string {
	switch (status) {
		case OutboxStatusEnum.PENDING:
			return RecordColorEnum.YELLOW;

		case OutboxStatusEnum.LEASED:
			return RecordColorEnum.BLUE;

		case OutboxStatusEnum.SUPERSEDED:
			return RecordColorEnum.GRAY;

		case OutboxStatusEnum.SENT:
			return RecordColorEnum.GREEN;

		case OutboxStatusEnum.FAILED:
			return RecordColorEnum.RED;

		case OutboxStatusEnum.DEAD_LETTERED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
